(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section--collection-filter"] && !window.DesignMode) return;
  try {
    
    document.querySelectorAll(".collection-link").forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.target.getAttribute("data-target");
        document.querySelector(`#${target}`).scrollIntoView({ 
        behavior: 'smooth' 
        });
      });
    });

    // Setup Intersection Observer
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.id;
        const link = document.querySelector(`.collection-link[data-target="${id}"]`);

        if (entry.isIntersecting) {
          document.querySelectorAll(".collection-link").forEach((link) => {
            link.classList.remove("active");
          });
          link.classList.add("active");

        } else {
          link.classList.remove("active");
        }
      });
    }, options);

    // Observe all target sections
    document.querySelectorAll(".collection-link").forEach((link) => {
      const targetId = link.getAttribute("data-target");
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        observer.observe(targetEl);
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--product-hero"] && !window.DesignMode) return;
  try {
      
  // document.addEventListener('DOMContentLoaded', function() {
    const flipItBtn = document.getElementById('flip-it-btn');
    const flipItFront = document.getElementById('flip-it-front');
    const flipItBack = document.getElementById('flip-it-back');
    const flipSvg = document.querySelector('.flip-svg');
    let isFlipped = false;

    flipItBtn.addEventListener('click', function() {
      if (isFlipped) {
        flipItFront.classList.remove("flipped")
        flipItBack.classList.remove("flipped")
        flipSvg.style.transform = "rotate(0deg)";
        isFlipped = false;
      } else {
        flipItFront.classList.add("flipped")
        flipItBack.classList.add("flipped")
        flipSvg.style.transform = "rotate(360deg)";
        isFlipped = true;
      }
    });
  // });

  } catch(e) { console.error(e); }
})();
})();
